// extracted by mini-css-extract-plugin
export default {"wrapper":"Sd_wrapper__3VPT4","section":"Sd_section__m0SnZ","content":"Sd_content__URG-D"};